import React, { useState } from "react";

import { getFormBody } from "@/components/widget/editor/utils/form-body";

import ReceiveDatabaseModal from "@/components/common/modals/receive-database-modal";

import {
  ContextMenuCheckboxItem,
  ContextMenuItem
} from "@/components/ui/context-menu";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";

const Relation: React.FC<
  React.ComponentProps<"div"> & {
    editorRef?: React.RefObject<HTMLDivElement>;
    rightClickedElement: HTMLElement;
  }
> = ({ editorRef, rightClickedElement }) => {
  const selectElement = rightClickedElement.matches("select")
    ? (rightClickedElement as HTMLSelectElement)
    : (rightClickedElement.closest("select") as HTMLSelectElement | null);
  const isSelect = Boolean(selectElement);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isSearchable, setIsSearchable] = useState(
    selectElement?.getAttribute("data-searchable") === "true"
  );

  const formBody = getFormBody(editorRef, rightClickedElement);

  return (
    <>
      {isSelect && (
        <ContextMenuCheckboxItem
          checked={isSearchable}
          onCheckedChange={(checked) => {
            if (!selectElement) return;

            const value = checked === true;

            setIsSearchable(value);

            selectElement.setAttribute(
              "data-searchable",
              value ? "true" : "false"
            );
          }}
        >
          قابل جستجو
        </ContextMenuCheckboxItem>
      )}

      <Dialog
        open={isModalOpen}
        onOpenChange={(open) => {
          if (!open) {
            setIsModalOpen(false);
          }
        }}
      >
        <DialogTrigger asChild>
          <ContextMenuItem
            onSelect={(e) => {
              e.preventDefault();
              setIsModalOpen(true);
            }}
          >
            واکشی دیتا
          </ContextMenuItem>
        </DialogTrigger>

        <DialogContent className="w-[900px] max-w-[95vw]">
          <ReceiveDatabaseModal
            onClose={() => {
              setIsModalOpen(false);
            }}
            element={rightClickedElement}
            formBody={formBody}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Relation;
